// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `























/**
 * Autor: Pontus Nilsson
 * Licencia: MIT
 * Más info: https://www.cssscript.com/realistic-ios-switch-pure-css/
 */
.form-switch[data-v-4d7a8891] {
  display: inline-block;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.form-switch.disable[data-v-4d7a8891] {
  pointer-events: none;
  opacity: 0.4;
}
.form-switch i[data-v-4d7a8891] {
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
  width: 46px;
  height: 26px;
  background-color: #e6e6e6;
  border-radius: 23px;
  vertical-align: text-bottom;
  transition: all 0.3s linear;
}
.form-switch i[data-v-4d7a8891]::before {
  content: '';
  position: absolute;
  left: 0;
  width: 42px;
  height: 22px;
  background-color: #fff;
  border-radius: 11px;
  transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
  transition: all 0.25s linear;
}
.form-switch i[data-v-4d7a8891]::after {
  content: '';
  position: absolute;
  left: 0;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-radius: 11px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
  transform: translate3d(2px, 2px, 0);
  transition: all 0.2s ease-in-out;
}
.form-switch:active i[data-v-4d7a8891]::after {
  width: 28px;
  transform: translate3d(2px, 2px, 0);
}
.form-switch:active input:checked + i[data-v-4d7a8891]::after {
  transform: translate3d(16px, 2px, 0);
}
.form-switch input[data-v-4d7a8891] {
  display: none;
}
.form-switch input:checked + i[data-v-4d7a8891] {
  background-color: #0cc175;
}
.form-switch input:checked + i[data-v-4d7a8891]::before {
  transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);
}
.form-switch input:checked + i[data-v-4d7a8891]::after {
  transform: translate3d(22px, 2px, 0);
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/toggles/Toggle.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;AAwBA;;;;EAIA;AAEA;EACA,qBAAA;EACA,eAAA;EACA,wCAAA;AAKA;AAFA;EAAA,oBAAA;EAAA,YAAA;AAAA;AAIA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,2BAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,oDAAA;EACA,4BAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,gCAAA;AACA;AAEA;EACA,WAAA;EACA,mCAAA;AACA;AAEA;EACA,oCAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,yBAAA;AACA;AAEA;EACA,qDAAA;AACA;AAEA;EACA,oCAAA;AACA","sourcesContent":["<template>\n  <label class=\"form-switch\" :class=\"{ disable }\">\n    <input type=\"checkbox\" :checked=\"value\" @input=\"$emit('input', !value)\" />\n    <i></i>\n  </label>\n</template>\n\n<script>\nexport default {\n  props: {\n    value: {\n      type: Boolean,\n      required: true,\n    },\n\n    disable: {\n      type: Boolean,\n      default: false,\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n/**\n * Autor: Pontus Nilsson\n * Licencia: MIT\n * Más info: https://www.cssscript.com/realistic-ios-switch-pure-css/\n */\n\n.form-switch {\n  display: inline-block;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n\n  &.disable {\n    @apply pointer-events-none opacity-40;\n  }\n}\n\n.form-switch i {\n  position: relative;\n  display: inline-block;\n  margin-right: 0.5rem;\n  width: 46px;\n  height: 26px;\n  background-color: #e6e6e6;\n  border-radius: 23px;\n  vertical-align: text-bottom;\n  transition: all 0.3s linear;\n}\n\n.form-switch i::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  width: 42px;\n  height: 22px;\n  background-color: #fff;\n  border-radius: 11px;\n  transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);\n  transition: all 0.25s linear;\n}\n\n.form-switch i::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  width: 22px;\n  height: 22px;\n  background-color: #fff;\n  border-radius: 11px;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);\n  transform: translate3d(2px, 2px, 0);\n  transition: all 0.2s ease-in-out;\n}\n\n.form-switch:active i::after {\n  width: 28px;\n  transform: translate3d(2px, 2px, 0);\n}\n\n.form-switch:active input:checked + i::after {\n  transform: translate3d(16px, 2px, 0);\n}\n\n.form-switch input {\n  display: none;\n}\n\n.form-switch input:checked + i {\n  background-color: #0cc175;\n}\n\n.form-switch input:checked + i::before {\n  transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);\n}\n\n.form-switch input:checked + i::after {\n  transform: translate3d(22px, 2px, 0);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
